import { t } from 'i18next'
import React from 'react'
import { parseMillisecondsToHoursAndMinutes } from '../../../../helpers/helpers'

const PermanenceSubTotalsDetailTableList = ({ subTotalReport }) => {
    return (
        <tr className='text-center'>
            <td className='custom-border blue-text'>
                {subTotalReport.building_code ? subTotalReport.building_code : '-'}
            </td>
            <td className='custom-border blue-text'>
                {subTotalReport.building_description ? subTotalReport.building_description : t('NO_ASSIGNMENT')}
            </td>
            <td
                className='custom-border dark-text'
                style={{ fontSize: '14px' }}
            >
                {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_normal).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_normal).split(':')[1])}min
            </td>
            <td
                className='custom-border dark-text'
                style={{ fontSize: '14px' }}
            >
                {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_50).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_50).split(':')[1])}min
            </td>
            <td
                className='custom-border dark-text'
                style={{ fontSize: '14px' }}
            >
                {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_100).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_100).split(':')[1])}min
            </td>
            <td className='blue-text'>
                {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_total).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(subTotalReport.hs_total).split(':')[1])}min
            </td>
        </tr>
    )
}

export default PermanenceSubTotalsDetailTableList